import IncomeStatement from '../pages/IncomeStatement/IncomeStatement';
import IncomeStatementV1 from '../pages/IncomeStatementV1';

const incomeStatementRoute = {
  public: [],
  auth: [
    // {
    //   name: 'income_statement',
    //   path: '/finance-and-accounting/income-statement',

    //   component: IncomeStatementV1,
    // },
    {
      name: 'income_statement_old',
      path: '/finance-and-accounting/income-statement',
      component: IncomeStatement,
    },
  ],
};

export default incomeStatementRoute;
